import GetLoading from "../../share/getLoading";
 

import React, { useEffect, useState, useMemo } from "react";
import { getCurrentUser, getPermission } from "../../share/getProfile";
import { Button, DatePicker, Select, Modal, Card, Tag, Space, Table, Avatar, message, Spin } from 'antd';
import dayjs from 'dayjs';
import { MinusCircleOutlined, ExclamationCircleOutlined, PlusCircleOutlined, EditOutlined, CloseOutlined, CopyOutlined, SaveOutlined, FilterOutlined, ReloadOutlined } from '@ant-design/icons';
import { request } from "../../share/request";
import { linkPath } from "../../share/helper";
import { PlusSquareOutlined, MinusSquareOutlined } from "@ant-design/icons";
import { boxHeader, boxHeaderTagText } from "../../styles/boxShadow";
import { BsDownload, BsPassFill } from "react-icons/bs";
import { BiCopy } from "react-icons/bi";
import FilterDate from "../../share/FilterDate";
import FilterDateTime from "../../share/FilterDateTime";
import ExcelJS from "exceljs";
import * as FileSaver from "file-saver";
const { Option } = Select;
const { confirm } = Modal;

const StaffSchedule = () => {
  const getProfileOrg = getCurrentUser();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [modalDepartment, setModalDepartment] = useState('');
  const [modalShift, setModalShift] = useState('');
  const [modalGroup, setModalGroup] = useState('');
  const [cards, setCards] = useState([{ id: Date.now(), date: null, staff: [] }]);
  const [departments, setDepartments] = useState([]);
  const [shifts, setShifts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [listSchedule, setListSchedule] = useState([])
  const [totalItems, setTotalItems] = useState(0)
  const [groups] = useState([
    { id: 1, name: 'Group A' },
    { id: 2, name: 'Group B' },
    { id: 3, name: 'Group C' }
  ]);
    const [objFilter, setObjFileter] = useState({
      org_code: getProfileOrg?.org_code  ,
       date_start: dayjs().startOf("month").format("YYYY-MM-DD"),
      date_end: dayjs().endOf("month").format("YYYY-MM-DD"),
      page: 1,
      pageSize: 10,
  });
    // -----------------  permisstion page --------------------
    const userPermission = getPermission();
    const weeklyReportValue = userPermission.find(
      (permission) => permission.pagename === "staffschedule"
    ) || { add: 0, edit: 0, deleted: 0 , print: 0};
    const {
      add: addvalue,
      edit: editvalue,
      deleted: deletevalue,
      print: printvalue,
    } = weeklyReportValue;
  const [selectedFilterDept, setSelectedFilterDept] = useState('');
  const [allStaff, setAllStaff] = useState([]);

  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [expandedData, setExpandedData] = useState({}); // store detail per row

  const [loadingSave, setLoadingSave] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [filteredDate, setFilteredDate] = useState({ start: null, end: null });
  const [openModel_Filter, setOpenModel_Filter] = useState(false);
  const getApi = async () => {
    const param = new URLSearchParams({
      org_code: getProfileOrg?.org_code || 20,
    });
    const res = await request('schedulegetshift?' + param.toString(), 'get', {});
    if (res?.ok === true) {
      setDepartments(res.api_dept || []);
      setShifts(res.api_shifts || []);
    }
  };

  const getApiListSchedule = async (objFilter) => {

    const param = new URLSearchParams({
      org_code: objFilter.org_code  ,
      date_start:  objFilter.date_start ,
      date_end: objFilter.date_end ,
      page:   objFilter.page ,
      pageSize:   objFilter.pageSize ,
    });

   try {
    setIsLoading(true);
     const res = await request(
      "schedulelist?" + param.toString(),
      "get",
      {}
    );

    if (res?.ok === true) {
      setListSchedule(res.data || []);
      setTotalItems(res.totalItem  || 0);
    }
    
   } catch (error) {
    
   }finally{
    setIsLoading(false);
   }
  };

  const fetchStaff = async (deptId, txtSearch = '') => {
    const param = new URLSearchParams({
      org_code: getProfileOrg?.org_code || 20,
    });

    if (!txtSearch.trim() && deptId) {
      param.append('dept_id', deptId);
    }

    if (txtSearch.trim()) {
      param.append('txtSearch', txtSearch.trim());
    }

    const res = await request(
      'schedulegetStaffInvite?' + param.toString(),
      'get',
      {}
    );

    if (res?.ok === true) {
      setAllStaff(res.api_staff_invite || []);
    }
  };

  useEffect(() => {
    getApi();
    getApiListSchedule(objFilter)
  }, []);

  useEffect(() => {
    if (isModalOpen) {
      fetchStaff(modalDepartment || undefined);
    }
  }, [isModalOpen, modalDepartment]);

  const addCard = () => {
    setCards([...cards, { id: Date.now(), date: null, staff: [] }]);
  };

  const updateCardField = (cardId, field, value) => {
    setCards(cards.map(card =>
      card.id === cardId ? { ...card, [field]: value } : card
    ));
  };

  const handleStaffChange = (cardId, selectedIds) => {
    const card = cards.find(c => c.id === cardId);
    if (!card) return;

    const fullStaffList = [...new Set([...(card.staff || []), ...allStaff])];
    const selectedStaff = selectedIds.map(id => fullStaffList.find(s => s.id === id)).filter(Boolean);

    setCards(cards.map(card =>
      card.id === cardId ? { ...card, staff: selectedStaff } : card
    ));
  };

  const toggleStaff = (cardId, staffId) => {
    setCards(cards.map(card => {
      if (card.id === cardId) {
        const safeStaff = card.staff || [];
        const staffIndex = safeStaff.findIndex(s => s.id === staffId);
        let newStaff;
        if (staffIndex > -1) {
          newStaff = safeStaff.filter(s => s.id !== staffId);
        } else {
          const fullStaffList = [...new Set([...safeStaff, ...allStaff])];
          const staff = fullStaffList.find(s => s.id === staffId);
          newStaff = staff ? [...safeStaff, staff] : safeStaff;
        }
        return { ...card, staff: newStaff };
      }
      return card;
    }));
  };
  const [copiedStaff, setCopiedStaff] = useState([]);

const handleCopyStaff = (sourceCardId) => {
  const sourceCard = cards.find(c => c.id === sourceCardId);
  if (!sourceCard || !sourceCard.staff || sourceCard.staff.length === 0) {
    message.warning('No staff to copy.');
    return;
  }
  message.success('Staff copied to buffer.');
  // Store copied staff temporarily
  setCopiedStaff([...sourceCard.staff]);
};

  

 
const handlePassStaff = (targetCardId) => {
  if (!copiedStaff || copiedStaff.length === 0) {
    message.warning("No staff to pass. Please copy first.");
    return;
  }

  setCards(cards.map(card => {
    if (card.id === targetCardId) {
      return { ...card, staff: [...copiedStaff] }; // paste staff
    }
    return card;
  }));

  message.success("Staff passed to selected card.");
};


const saveSchedule = async () => {
  if (!modalDepartment) {
    message.error("Please select a department.");
    return;
  }

  const deptName =
    departments.find(d => d.id == modalDepartment)?.department_name || '';

  const create_by =
    getProfileOrg?.username || getProfileOrg?.name || 'Unknown';

  // Only valid cards
  const validCards = cards.filter(
    card => card.date && (card.staff || []).length > 0
  );

  if (validCards.length === 0) {
    message.warning("Please select date and staff for at least one card.");
    return;
  }
setLoadingSave(true)
  try {
    for (const card of validCards) {
      const payload = {
        shiftId: modalShift || null,
        dept_id: modalDepartment,
        date_shift: card.date,
        staffList: card.staff.map(s => ({ id: s.id })),
        create_by: 'Admin'
      };

      // 🔹 Add applyshift_id only in EDIT mode
      if (isEditing) {
        payload.applyshift_id = editingId;
      }

      const res = await request(
        'scheduleapplyshiftsavetodb',
        isEditing ? 'put' : 'post',   // 🔥 KEY CHANGE
        payload
      );

      // ❌ error
      if (!res || (isEditing ? res.isOk !== 6 : res.isOk !== 5)) {
        let msg = res?.message || "Unknown error";

        if (res?.isOk === 2) {
          msg = `Duplicate: Staff already scheduled in ${deptName} on ${dayjs(card.date).format('DD/MM/YYYY')}`;
        }

        message.error(msg);
        return;
      }
    }

    // ✅ success
    message.success(
      isEditing
        ? "Schedule updated successfully!"
        : "All schedules saved successfully!"
    );
setLoadingSave(false);
    // refresh list
    await getApiListSchedule(objFilter);

    // reset expand rows
    setExpandedData({});
    setExpandedRowKeys([]);

    resetModal();

  } catch (err) {
    console.error(err);
    message.error("Failed to save schedule. Please try again.");
  }finally{
    
  }
};

  const resetModal = () => {
    setCards([{ id: Date.now(), date: null, staff: [] }]);
    setModalDepartment('');
    setModalShift('');
    setModalGroup('');
    setIsEditing(false);
    setEditingId(null);
    setIsModalOpen(false);
  };

  // const handleAddNew = (deptName) => {
  //   let deptId = deptName;
  //   if (deptName) {
  //     const deptObj = departments.find(d => d.department_name === deptName);
  //     deptId = deptObj ? deptObj.id : '';
  //   }
    
  //   setModalDepartment(deptName.department_name);
  //   setModalShift(deptName.shift_id || '');
  //   console.log('data deptName:',modalDepartment)
  //   setModalGroup('');
  //   setCards([{ id: Date.now(), date: null, staff: [] }]);
  //   setIsEditing(false);
  //   setEditingId(null);
  //   setIsModalOpen(true);
  // };
const handleAddNew = (record) => {
  // record = row data from table
  const deptId = record?.dept_id || '';
  const shiftId = record?.shift_id || '';

  setModalDepartment(deptId);   // ✅ Select expects ID
  setModalShift(shiftId);       // ✅ shift_id
  setModalGroup('');
  setCards([{ id: Date.now(), date: null, staff: [] }]);
  setIsEditing(false);
  setEditingId(null);
  setIsModalOpen(true);

  console.log('Add new for dept_id:', deptId, 'shift_id:', shiftId);
};

  const removeCard = (cardId) => {
    setCards(cards.filter(card => card.id !== cardId));
  };

  const handleEdit = (record) => {
    setModalDepartment(record.dept_id || '');
    setModalShift(record.shift_id || '');
    setModalGroup(record.group || '');
    const card = {
      id: Date.now(),
      date: record.date_shift,
      staff: record.staff_list || []
    };
    setCards([card]);
    setIsEditing(true);
    setEditingId(record.applyshift_id);
    setIsModalOpen(true);
  };

  const handleDelete = (applyshift_id) => {
    confirm({
      title: 'Are you sure you want to delete this schedule?',
      icon: <ExclamationCircleOutlined />,
      content: 'This action cannot be undone.',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        // Assume delete API call here
        // await request('scheduledelete', 'post', { applyshift_id });
        // For now, just refetch
        getApiListSchedule().then(() => {
          message.success('Schedule deleted successfully');
        }).catch(() => {
          message.error('Failed to delete schedule');
        });
      },
    });
  };

  // Sort cards by date for better visual order
  const sortedCards = useMemo(() => {
    return [...cards].sort((a, b) => {
      if (!a.date && !b.date) return 0;
      if (!a.date) return 1;
      if (!b.date) return -1;
      return dayjs(a.date).diff(dayjs(b.date));
    });
  }, [cards]);
  const [loadingExpandId, setLoadingExpandId] = useState(null);
  const loadDataForKey = async (key) => {
    if (expandedData[key]) return;

    let idsArray;
    try {
      idsArray = JSON.parse(key || '[]');
    } catch (e) {
      idsArray = (key || '').split(',').map(id => parseInt(id.trim())).filter(id => !isNaN(id));
    }
    if (idsArray.length === 0) return;
      setLoadingExpandId(key); // ✅ START loading (USE KEY)

    try {
      const res = await request(
        'schedulelistdetail?ids=' + idsArray.join(','),
        'get',
        {}
      );

      if (res?.ok) {
        setExpandedData(prev => ({ ...prev, [key]: res.data || [] }));
      }
    } catch (err) {
      console.error(err);
    }finally {
        setLoadingExpandId(null); // Stop loading
      }
  };

  const handleExpandedRowsChange = async (newExpandedRowKeys) => {
    console.log('New expanded keys:', newExpandedRowKeys);
    setExpandedRowKeys(newExpandedRowKeys);

    // Load data for newly expanded rows
    const newlyExpanded = newExpandedRowKeys.filter(key => !expandedRowKeys.includes(key));
    for (const key of newlyExpanded) {
      await loadDataForKey(key);
    }
  };

  const components = {
    header: {
      cell: (props) => (
        <th
          {...props}
          style={{
            backgroundColor: "#1f75c6ff", // blue header bg
            color: "white",
            fontWeight: "bold",
            textAlign: "center",
            ...props.style,
          }}
        >
          {props.children}
        </th>
      ),
    },
  };

  const subColumns = [
    { title: 'ID', dataIndex: 'applyshift_id', key: 'applyshift_id' },
    {
      title: 'ឈ្មោះវេនយាម',
      key: 'shift_name_kh',
      render: (_, record) => {
        return(
          <>
          <div style={{marginBottom:1,fontWeight:'bold'}}>{record.shift_name_kh}</div>
          <span style={{fontSize:9,fontWeight:'bold'}}>    {record.on_duty_time} - {record.off_duty_time}</span>
          </>
        )
      }
    },
    { title: 'ក្រុម', dataIndex: 'group', key: 'group', render: (text) => text || '-' },
    {
      title: 'សមាជិក',
      dataIndex: 'staff_list',
      key: 'staff_list',
      render: (staff_list) => {
        const safeStaff = staff_list || [];
        return safeStaff.length > 0 ? (
          <Avatar.Group maxCount={3} size="mindle">
            {safeStaff.map(s => (
              <Avatar
                key={s.id}
                src={linkPath + (s.image || '')}
                title={s.fullname}
              />
            ))}
          </Avatar.Group>
        ) : '-';
      }
    },
    {
      title: 'ថ្ងៃខែយាម',
      dataIndex: 'date_shift',
      key: 'date_shift',
      render:(text)=>{
        return (
          <div>
            <Tag color="green"style={{paddingTop:2,paddingBottom:2}}>{formatDateKhmer(text)}</Tag>
          </div>
        )
      }
      // render: (text) => text ? dayjs(text).format('YYYY-MM-DD') : '-'
    },
    {
      title: 'ថ្ងៃបង្កើត',
      dataIndex: 'create_date',
      key: 'create_date',
      render: (text) => text ? dayjs(text).format('DD/MM/YYYY') : '-'
    },
    { title: 'បង្កើតដោយ', dataIndex: 'create_by', key: 'create_by' },
    {
      title: 'សកម្មភាព',
      key: 'action',
      render: (_, record) => (
        <Space>
          
      {Boolean(editvalue)&&(
              <Button
                
                  color="green"
                  variant="filled"
                onClick={() => handleEdit(record)}
                  icon={<EditOutlined />}
                />
      )}
          
           {Boolean(deletevalue)&&(  <Button
                   
                    color="red"
                    variant="filled"
                    onClick={() => handleDelete(record.applyshift_id)}
                    icon={<CloseOutlined />}
                  />)}
        </Space>
      )
    }
  ];

  const expandedRowRender = (record) => {
    const rowKey = record.ids;

  if (loadingExpandId === rowKey) {
    return (
      <div style={{ padding: 16, textAlign: "center" }}>
        <Spin tip="Loading..." />
      </div>
    );
  }


 
    const details = expandedData[rowKey] || [];
    return (
     <div style={{marginTop:'1px',marginLeft:'50px'}}>
      <Table
        components={components}
        columns={subColumns}
        dataSource={details}
        pagination={false}
        size="small"
        rowKey="applyshift_id"
      /></div>
    );
  };

  const filteredData = useMemo(() => {
    if (!selectedFilterDept) return listSchedule;
    return listSchedule.filter(record => record.department_name === selectedFilterDept);
  }, [listSchedule, selectedFilterDept]);

const daysKhmer = ['អាទិត្យ', 'ច័ន្ទ', 'អង្គារ', 'ពុធ', 'ព្រហស្បតិ៍', 'សុក្រ', 'សៅរ៍'];

const formatDateKhmer = (date) => {
  if (!date) return '';
  const d = dayjs(date);
  const dayName = daysKhmer[d.day()]; // ចាប់ថ្ងៃនៅខ្មែរ
  return `${dayName}, ${d.format('DD/MM/YYYY')}`;
};
  const onChangePage = (number) => {
    setPageNumber(number);

    setObjFileter({
       ...objFilter,
        page: number,

     
    });
    console.log('objFilter change page:', objFilter);
    getApiListSchedule(objFilter);
  };

  const handleFilterDateChange = async (dateRange) => {
    setFilteredDate(dateRange); // save it
    console.log("Received from FilterDate:", dateRange.start, dateRange.end);

    const newFilter = {
      ...objFilter,
      date_start: dateRange.start,
      date_end: dateRange.end,
    };
    setObjFileter(newFilter);
    getApiListSchedule(newFilter);
  };
   const handleClearSearch = () => {
 
  
    const newFilter = {
      ...objFilter,
    date_start: dayjs().startOf("month").format("YYYY-MM-DD"),
    date_end: dayjs().endOf("month").format("YYYY-MM-DD"),
    };
    
    setObjFileter(newFilter);
    getApiListSchedule(newFilter);

  };
    const [modalReport,setModalReport] =useState(false)

  const handleGetReport =()=>{
      setModalReport(true)
}

  
 
 

const handleDownloadReport = async (dateRange) => {
  try {
    const params = new URLSearchParams({
      org_code: 20,
      date_start: `${dateRange.date_start}`,
      date_end: `${dateRange.date_end}`,
    });

    const res = await request(`schedulelistgetreportworkshift?${params.toString()}`, "get", {});
    if (!res || typeof res !== "object") return;

    const rawDetails = Array.isArray(res.api_summaryreportshifts) ? res.api_summaryreportshifts : [];
    const dataRows = Array.isArray(rawDetails[0]) ? rawDetails[0] : rawDetails;
    const filteredDetails = dataRows.filter(row => row && typeof row === "object");

    const templatePath = process.env.PUBLIC_URL + "/template/applyworkshift_sum_report.xlsx";
    const response = await fetch(templatePath);
    const arrayBuffer = await response.arrayBuffer();

    const workbook = new ExcelJS.Workbook();
    await workbook.xlsx.load(arrayBuffer);

    const worksheet = workbook.getWorksheet(1) || workbook.addWorksheet("reports");




    if (worksheet.rowCount >= 6) {
      worksheet.spliceRows(6, worksheet.rowCount - 5); // keep rows 1–5
    }

    // 1️⃣ Add cover label, organization name, and report title
    worksheet.getCell("A3").value = getProfileOrg.org_cover_by || "";
    worksheet.getCell("A4").value = getProfileOrg.org_name_kh || "";
    worksheet.getCell("A5").value = `តារាងវេនយាមប្រចាំការ ចាប់ថ្ងៃទី ${dayjs(dateRange.date_start).format('DD/MM/YYYY')} ដល់ថ្ងៃទី ${dayjs(dateRange.date_end).format('DD/MM/YYYY')}`;



    if (filteredDetails.length === 0) {
      const buffer = await workbook.xlsx.writeBuffer();
      FileSaver.saveAs(
        new Blob([buffer]),
        `វេនយាម_sum_report_${dateRange.date_start}_${dateRange.date_end}.xlsx`
      );
      return;
    }

    // Add headers at row 6
    const headers = Object.keys(filteredDetails[0]);
    const headerRowNumber = 6;
    const headerRow = worksheet.getRow(headerRowNumber);
    headers.forEach((header, index) => {
      headerRow.getCell(index + 1).value = header;
    });
 
    headerRow.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFD9EAD3" } ,};
    headerRow.alignment = { wrapText: true, vertical: 'middle' };
    // Apply borders to each cell in the header row
    headerRow.eachCell((cell) => {
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };
    });
    headerRow.commit();

    // Add data rows starting from row 7
    filteredDetails.forEach((rowData, i) => {
      const row = worksheet.getRow(headerRowNumber + 1 + i);
      headers.forEach((header, index) => {
        let value = rowData[header];

        // Format date for the first column
        if (index === 0 && value) {
          value = formatDateKhmer(value);
        }

        // Staff names with line breaks
        if (Array.isArray(value)) {
          value = value.join("\n");
        } else if (typeof value === "string") {
          value = value.replace(/,\s*/g, "\n");
        }

        row.getCell(index + 1).value = value || "";
        row.getCell(index + 1).alignment = { wrapText: true, vertical: 'top' };

        // Add border
        row.getCell(index + 1).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
      });
      row.commit();
    });
 // Minimize unused rows from last data row +1 to row 99 by setting tiny height (0.5 points ~ invisible)
    const lastDataRowNumber = headerRowNumber + filteredDetails.length;
    for (let r = lastDataRowNumber + 1; r <= 99; r++) {
      const row = worksheet.getRow(r); // getRow creates if not exists
      row.height = 0.5; // Set minimal height instead of hidden (workaround if hidden doesn't render)
    }

    worksheet.columns.forEach((column) => {
      column.width = column.width || 25;
    });

    const buffer = await workbook.xlsx.writeBuffer();
    FileSaver.saveAs(
      new Blob([buffer]),
      `វេនយាម_sum_report_${dateRange.date_start}_${dateRange.date_end}.xlsx`
    );

  } catch (err) {
    console.error("Download failed:", err);
  }
};

 

  return (
    <div>
           <div className="sprinSave-container">
        {/* Your other components */}
        {isLoading && (
          <div className="sprinSave">
            <GetLoading />
          </div>
        )}
      </div>
        <div style={boxHeader}>
        <div style={{ display: "flex" }}>
          <Space>
            {boxHeaderTagText("ការគ្រប់គ្រង់ ក្រុមវេនយាម")}
            <div style={{ display: "flex" }}>
            
      <div style={{ marginBottom: '16px', marginTop: '16px' }}>
        <label>ស្វែងរក:</label>
  <Space>      <Select
          value={selectedFilterDept}
          onChange={setSelectedFilterDept}
          style={{ width: 200, marginLeft: '8px' }}
          placeholder="All Departments"
          allowClear
        >
          {departments.map(dept => (
            <Option key={dept.id || dept.code} value={dept.department_name}>
              {dept.department_name}
            </Option>
          ))}
        </Select>
             <Button
                  type="primary"
                  onClick={() => {
                    setOpenModel_Filter(true);
                  }}
                  icon={<FilterOutlined />}
                />
                   <Button
                  danger
                  type="primary"
                  onClick={handleClearSearch}
                  icon={<ReloadOutlined />}
                />
                </Space>
      </div>
            </div>
          </Space>
        </div>
        <div style={{ display: "flex" }}>
   
          <Space>
                   {Boolean(printvalue) && (
                     <Button
              
           color="green" variant="solid"
              onClick={handleGetReport}
              icon={<BsDownload />}
            >
              ទាញរបាយការណ៍
            </Button>
                   )}
      {Boolean(addvalue) && (
              <Button 
            
            icon={<PlusCircleOutlined/>} type="primary" onClick={() => handleAddNew('')}>
        បន្ថែមវេនយាមថ្មី
      </Button>
      )}
          </Space>
        </div>
      </div>
    


      <Table
        dataSource={filteredData}
        rowKey={(record) => record.ids}
      
        columns={[
          { title: 'ID', dataIndex: 'id', key: 'id' },
          // { title: 'IDs', dataIndex: 'ids', key: 'ids' },
          { title: 'ផ្នែក', dataIndex: 'department_name', key: 'department_name' },
          { title: 'សរុបចំនួនកំណត់ត្រា', dataIndex: 'total_entrie', key: 'total_entrie' },
          {
            title: 'សកម្មភាព',
            key: 'action',
            render: (_, record) => (
           
              <>
              {Boolean(addvalue) && ( <Button
                  className="buttonstylekhmer"
                  type="primary"
                   onClick={() => handleAddNew(record)}
                  icon={<PlusCircleOutlined />}
                />)}</>
            )
          }
        ]}
        expandable={{
          expandedRowRender,
          expandedRowKeys,
          onExpandedRowsChange: handleExpandedRowsChange,
        }}
         pagination={{
              pageSize: 10,
              total: totalItems,
               current: pageNumber,
              onChange: (page) => onChangePage(page), // ✅ Pass the new page number
            }}
        style={{ marginTop: '20px' }}
      />
{/* Filter */}
  <Modal title="ស្វែងរក" open={openModel_Filter} footer={false}>
        <FilterDate
          closeModelFilter={() => setOpenModel_Filter(false)}
          onFilterDateChange={handleFilterDateChange}
        />
      </Modal>
 {/* Report  */}
             <Modal title="ទាញរបាយការណ៍" open={modalReport} footer={true}>
          <FilterDateTime
            closeModelFilter={() => setModalReport(false)}
            onFilterDateChange={handleDownloadReport}
          />
        </Modal>
      {/* Modal */}
      <Modal
        title={isEditing ? "កែប្រែកាលវិភាគ" : "បង្កើតកាលវិភាគសមាជិកយាម"}
        open={isModalOpen}
        onOk={saveSchedule}
        onCancel={resetModal}
        okText="Save"
        cancelText="Cancel"
     
        width={900}
        footer={[
          !isEditing && (
            <Button  color="purple" variant="solid" key="add" onClick={addCard}
             icon={<PlusCircleOutlined />}
            style={{ marginRight: '10px' }}>
              Add Card
            </Button>
          ),
          <Button key="cancel" color="danger" variant="solid" icon={<CloseOutlined />} onClick={resetModal}>
            Cancel
          </Button>,
          <Button key="save" icon={<SaveOutlined />} type="primary" 
            loading={loadingSave}
          onClick={saveSchedule}>
            {isEditing ? 'Update' : 'Save'}
          </Button>,
        ]}
      >
        <Space direction="vertical" style={{ width: '100%', marginBottom: '16px' }}>
          <div>
            <label>នាយកដ្ឋាន /ផ្នែក:</label>
            <Select
              showSearch
              value={modalDepartment}
              onChange={(value) => {
                setModalDepartment(value);
                fetchStaff(value);
              }}
              style={{ width: '100%', marginTop: '4px' }}
              placeholder="Select Department"
              allowClear
              filterOption={(input, option) =>
                (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
              }
            >
              {departments.map(dept => (
                <Option key={dept.id || dept.code} value={dept.id || dept.code}>
                  {dept.department_name}
                </Option>
              ))}
            </Select>
          </div>
          <div>
            <label>វេនយាមម៉ោង:</label>
            <Select
              value={modalShift}
              onChange={setModalShift}
              style={{ width: '100%', marginTop: '4px' }}
              placeholder="Select Shift"
              allowClear
            >
              {shifts.map(shiftItem => (
                <Option key={shiftItem.id} value={shiftItem.id}>
                  {shiftItem.shift_name_kh} ({shiftItem.on_duty_time} - {shiftItem.off_duty_time})
                </Option>
              ))}
            </Select>
          </div>
          <div>
            <label>ក្រុម (Optional):</label>
            <Select
              value={modalGroup}
              onChange={setModalGroup}
              style={{ width: '100%', marginTop: '4px' }}
              placeholder="Select Group"
              allowClear
            >
              {groups.map(groupItem => (
                <Option key={groupItem.id} value={groupItem.name}>
                  {groupItem.name}
                </Option>
              ))}
            </Select>
          </div>
        </Space>

        {sortedCards.map((card, index) => {
          // Unique staff list: selected + currently searched
          const staffMap = new Map();
          (card.staff || []).forEach(staff => staff && staffMap.set(staff.id, staff));
          allStaff.forEach(staff => staff && staffMap.set(staff.id, staff));
          const uniqueStaff = Array.from(staffMap.values());

          const cardStaffOptions = uniqueStaff.map(staff => (
            <Option key={staff.id} value={staff.id}>
              <Space>
                <img
                  src={linkPath + (staff.image || '')}
                  alt={staff.fullname}
                  style={{ width: '20px', height: '20px', borderRadius: '50%' }}
                />
                {staff.fullname} {staff.position_kh ? `- ${staff.position_kh}` : ''}
              </Space>
            </Option>
          ));

          return (
            <Card
              key={card.id}
              title={
             <span style={{ color: '#fff' }}>
  វេនយាម {index + 1} - {formatDateKhmer(card.date)}
</span>
              }
              size="small"
              style={{ marginBottom: '16px' }}
              headStyle={{
                backgroundColor: '#0955ebff',
                color: '#fff',
              }}
              extra={
                sortedCards.length > 1 && (
                  <Button
                    type="text"
                    danger
                    icon={<MinusCircleOutlined />}
                    onClick={() => removeCard(card.id)}
                  />
                )
              }
            >
              <Space direction="vertical" style={{ width: '100%' }}>
                <div>
                  <label>ថ្ងៃខែយាម:</label>
                  <DatePicker
                    format={'DD/MM/YYYY'}
                    value={card.date ? dayjs(card.date) : null}
                    onChange={(date) => {
                      updateCardField(card.id, 'date', date ? date.format('YYYY-MM-DD') : null);
                    }}
                    style={{ width: '100%', marginTop: '4px' }}
                    placeholder="Select date"
                  />
                </div>
                <div>
                  <label>សមាជិកក្រុមយាម:</label>
                 <div  style={{display:'flex',flexDirection:'row',alignContent:'start'}} >
                   <Select
                    showSearch
                    mode="multiple"
                    value={(card.staff || []).map(s => s.id)}
                    onChange={(selectedIds) => handleStaffChange(card.id, selectedIds)}
                    onSearch={(search) => fetchStaff(modalDepartment || undefined, search)}
                    style={{ width: '100%', marginTop: '4px' }}
                    placeholder="Search and select staff"
                    filterOption={false}
                  >
                    {cardStaffOptions}
                  </Select>
                <div style={{display:'flex',alignItems:'start'}}>
                    <Space   style={{marginLeft:'8px',marginTop:'4px'}}>
                  {/* copy all staff from  this card   to other card  */}
                   <Button  color="default" variant="solid" icon={<BiCopy/>} onClick={() => handleCopyStaff(card.id)} >Copy </Button>
                     <Button  color="cyan" variant="solid" icon={<BsPassFill/>} onClick={() => handlePassStaff(card.id)}
 >Pass </Button>
                  </Space>  
                </div>
                 </div>
                  <Space wrap style={{ marginTop: '8px' }}>
                    {(card.staff || []).map(selectedStaff => (
                      <Tag
                        key={selectedStaff.id}
                        closable
                        onClose={() => toggleStaff(card.id, selectedStaff.id)}
                      >
                        <img
                          src={linkPath + (selectedStaff.image || '')}
                          alt={selectedStaff.fullname}
                          style={{ width: '32px', height: '32px', borderRadius: '50%', marginRight: '8px' }}
                        />
                        {selectedStaff.fullname}
                      </Tag>
                    ))}
                  </Space>
                  
                </div>
              </Space>
            </Card>
          );
        })}
      </Modal>
    </div>
  );
};

export default StaffSchedule;